import { useEffect } from "react";
import { useTranslation } from 'react-i18next';

export default function SelectTransactionType(props) {
  const { t } = useTranslation();
  const { type, setType, editMode } = props;
  const exactType = "exact";
  const shareType = "share";

  useEffect(() => {
    if (!type) {
      setType(shareType);
    }
  }, [type, setType]);

  return (
    <ul className="nav nav-tabs card-header-tabs">
    {(editMode || type === shareType) &&
      <li className="nav-item">
        <a
          className={`small nav-link ${type === shareType ? "active" : ""}`}
          onClick={() => setType(shareType)}
          href="#!"
          style={editMode? {pointerEvents: ""} : {pointerEvents: "none"}}
        >
          {t('transaction.shares')}
        </a>
      </li>
    }
    {(editMode || type === exactType) &&
      <li className="nav-item">
        <a
          className={`small nav-link ${type === exactType ? "active" : ""}`}
          onClick={() => setType(exactType)}
          href="#!"
          style={editMode? {pointerEvents: ""} : {pointerEvents: "none"}}
        >
          {t('transaction.exact_amounts')}
        </a>
      </li>
    }
    </ul>
  );
}
